import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import {COLLABORATOR_POSITION}  from '../../../utils/ConstantsMain';
import "../../../components/AddLawyers/addLawyers.scss";
import { isMobile } from 'react-device-detect';
import {
  MenuItem,
  FormHelperText,
  InputLabel,
  FormControl,
  Select,
} from '@material-ui/core';

const styles = () => ({
  inputLabelRoot: {
    transform: 'translate(14px, 16px) scale(1)',
  },
  inputLabelShrink: {
    transform: 'translate(14px, -6px) scale(0.75)',
    backgroundColor: '#fff',
    zIndex: 10,
  },
  heightSelect: {
    height: 76,
    margin: isMobile ? '0 0 25px 0' : '0 0 25px 0',
  },
  formHelperTextRoot: {
    margin: '8px 14px',
    marginBottom: 0,
  },  
  ButtonBase: {
    padding: 0,
    margin: 0,
    width: isMobile ? 139 : 160,
    minWidth: 'initial',
  },
  linkStyle: {
    width: isMobile ? 139 : 160,
    margin: '0 10px 0 0',
    '&:$last-child': {
      margin: 0
    }
  },
  form: {
    width: '100%',
  },
  buttonContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-around',
  },
});

const HolderForm = props => {

  const {
    values,
    isValid,
    handleChange,
    handleSubmit,
    touched,
    errors,
    classes,
    handleClose
  } = props;
  
  return (
    <>
      <form className={classes.form}>
        <FormControl
          style={{ maxWidth: '536px' }}
          classes={{ root: classes.heightSelect }}
          variant="outlined"
          error={touched.collaboratorPosition && errors.collaboratorPosition ? true : false}
        >
          <InputLabel
            htmlFor="select-multiple-checkbox"
            classes={{
              root: classes.inputLabelRoot,
              shrink: classes.inputLabelShrink,
            }}
          >
            {'Puesto del colaborador'}
          </InputLabel> 
            <Select
              id='collaboratorPosition'
              name='collaboratorPosition'
              value={values.collaboratorPosition ? values.collaboratorPosition : []}
              onChange={handleChange}
            >
              {COLLABORATOR_POSITION && COLLABORATOR_POSITION.map((item, index) => (
                <MenuItem key={index} value={item.value} >
                  {item.name}
                </MenuItem>
              ))}
          </Select>
          {touched.collaboratorPosition && errors.collaboratorPosition && (
            <FormHelperText classes={{ root: classes.formHelperTextRoot }}>
              {errors.collaboratorPosition}
            </FormHelperText>
          )}
        </FormControl>

        <div className="addLawyers_horizontal-layout" style={{ marginTop: 15 }}>
          <div className={classes.buttonContainer}>
            <ButtonBase
              type="button"
              onClick={handleClose}
              variant="primarySolidOutlined"
              linkStyle={classes.linkStyle}
              className={classes.ButtonBase}
            >
              Cancelar
            </ButtonBase>

            <ButtonBase
              type="submit"
              onClick={handleSubmit}
              variant="primary"
              linkStyle={classes.linkStyle}
              className={classes.ButtonBase }
              style={{ marginRight: 16}}
              disabled={!isValid}
            >
              Crear
            </ButtonBase>
          </div>
        </div>
      </form>
    </>
  )
};


export default withStyles(styles)(HolderForm);
